import { ThemeProperties } from '../../core';

export interface AccordionTheme {
	headerFont: string;
	bodyFont: string;
}
export const theme = new ThemeProperties('accordion');
